import React, { useState } from "react";
import ChatSidebarHeader from "../../../../components/common/ChatSidebarHeader";
import {
  EditOutlined,
  MessageOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import { Flex, Switch, Typography } from "antd";
import { toast } from "react-toastify";
import ENDPOINTS from "../../../../services/endpoint";
import apiInstance from "../../../../services/apiService";
import "./index.scss";

const { Title, Text } = Typography;

interface GroupPermissionsProps {
  handleBackToInfo: () => void;
  currentChat: any;
}

const GroupPermissions: React.FC<GroupPermissionsProps> = ({
  handleBackToInfo,
  currentChat,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const groupPermissions = [
    {
      id: 1,
      icon: <EditOutlined />,
      label: "Edit group settings",
      checked: currentChat.groupSettings.editGroup,
    },
    {
      id: 2,
      icon: <MessageOutlined />,
      label: "Enable Call/Messages",
      checked: currentChat.groupSettings.sendMessage,
    },
    {
      id: 3,
      icon: <UserAddOutlined />,
      label: "Add other members",
      checked: currentChat.groupSettings.addOthersMembers,
    },
  ];

  const handleChange = async (option: any, value: boolean) => {
    const URL = ENDPOINTS.GROUP_PERMISSION_UPDATE;

    const key =
      option.id === 1
        ? "editGroup"
        : option.id === 2
        ? "sendMessage"
        : "addOthersMembers";

    setLoading(true);
    try {
      const response = await apiInstance.post(URL, {
        groupId: currentChat.id,
        [key]: value.toString(),
      });

      if (response.status === 200) {
        toast.success("Updated Successfully");
      }
    } catch (err: any) {
      toast.error(err.message || "There was an error. Please try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ChatSidebarHeader
        title="Group Permissions"
        handleBackClick={handleBackToInfo}
      />

      <div className="permissions-container">
        <Title className="heading">Members can</Title>

        <Flex vertical gap={10}>
          {groupPermissions.map((option) => (
            <Flex key={option.id} align="center" gap={10}>
              <div className="icon">{option.icon}</div>
              <Text className="label">{option.label}</Text>
              <div className="custom-switch">
                <Switch
                  disabled={loading}
                  onChange={(e: boolean) => handleChange(option, e)}
                  defaultChecked={option.checked}
                />
              </div>
            </Flex>
          ))}
        </Flex>
      </div>
    </>
  );
};

export default GroupPermissions;
